export const environment = {
  production: false,
  baseUrl: '',

  api_cns_portal: '/sicns',
  api_java_auth: '/cad-maquina-api/auth',
  api_java_consulta_maquina: '/cad-maquina-api/api/consulta/maquina/',
   api_java_cadastra_maquina: '/cad-maquina-api/api',
  api_java_historico_maquina: '/cad-maquina-api/api/historico',
  api_java_altera_maquina: '/cad-maquina-api/api/cadastro/alterar',  
  api_java_altera_estado_maquina: '/cad-maquina-api/api/estado/alterar',
   
  api_node: '/cns-node/',
  api_node_cert_bloq: '/cns-node/api/certificado/bloqueio/',
  api_node_cert_val: '/cns-node/api/certificado/valido/',
  api_node_obter_perfil: '/cns-node/api/certificado/perfil/',

  api_node_proc_existe: '/cns-node/api/procuracao/verificaProcuracaoExiste',
  api_node_dados_outorgante: '/cns-node/api/certificado/outorgante/',
  api_node_serv_outorga: '/cns-node/api/procuracao/lista-servicos-outorga',
  api_node_cert_situacao: '/cns-node/api/certificado/situacao/',
 
  api_download_kriptonita: 'https://www.caixa.gov.br/Downloads/fgts-conectividade-social/installcriptocns.zip',
  //manual
  manual_cns: '/ajuda/#/menu-ajuda',
};


